import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Mail, MapPin, Twitter, Github, Linkedin, Heart } from 'lucide-react';

const Footer = () => {
  const { user } = useContext(AuthContext);
  return (
    <footer className="footer bg-surface border-t border-white/5 pt-16 pb-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">

          {/* Brand Column */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold font-display text-white">IdeaPlatform</h3>
            <p className="text-slate-400 leading-relaxed text-sm">
              A community-driven platform where innovators connect, share ideas, and shape the future together.
              We believe in the power of collective creativity.
            </p>
            <div className="flex gap-4">
              {/* <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-primary hover:text-white transition-all duration-300">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-secondary hover:text-white transition-all duration-300">
                <Github className="w-5 h-5" />
              </a> */}
              <a href="https://www.linkedin.com/in/ankit-patidar-495649219/"
                target="_blank"
                rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:bg-primary hover:text-white transition-all duration-300">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold font-display text-white">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-slate-400 hover:text-primary transition-colors text-sm">Home</a></li>
              <li><a href="/submit" className="text-slate-400 hover:text-primary transition-colors text-sm">Submit Idea</a></li>
              {!user && (
                <>
                  <li><a href="/login" className="text-slate-400 hover:text-primary transition-colors text-sm">Login</a></li>
                  <li><a href="/signup" className="text-slate-400 hover:text-primary transition-colors text-sm">Join Us</a></li>
                </>
              )}
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold font-display text-white">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3 text-slate-400 text-sm">
                <Mail className="w-5 h-5 text-secondary shrink-0" />
                <span>indorepalotra@gmail.com</span>
              </div>
              <div className="flex items-start gap-3 text-slate-400 text-sm">
                <MapPin className="w-5 h-5 text-secondary shrink-0" />
                <span>Ankit Patidar,A-6(j-22)<br />Civil line, Jaipur 302006, India</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; 2026 Idea Platform. All rights reserved.
          </p>
          <div className="flex items-center gap-1 text-slate-500 text-sm">
            <span>Made with</span>
            <Heart className="w-4 h-4 text-red-500 fill-red-500" />
            <span>for innovators.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
